import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SurveyFlow from './pages/SurveyFlow';
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import EventEditor from './pages/admin/EventEditor';
import Reports from './pages/admin/Reports';
import ProtectedRoute from './components/admin/ProtectedRoute';
import { getEvents } from './services/api';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/survey/:id" element={<SurveyFlow />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/events/new"
          element={
            <ProtectedRoute>
              <EventEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/events/:id"
          element={
            <ProtectedRoute>
              <EventEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/reports"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/reports/:eventId"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Home />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

function Home() {
  const [events, setEvents] = useState<Array<{ id: number; name: string; slug: string }>>([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    getEvents()
      .then((list) => setEvents(list))
      .catch(() => setEvents([]));
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const latestEvent = events[0];

  return (
    <div className="page page--home">
      <div className="home-card">
        <h1 className="home-card__title">The Living Room</h1>
        <p className="home-card__subtitle">Event surveys</p>
        <p className="home-card__text">
          If you have a survey link, open it to take the survey. Or use the menu below.
        </p>

        <div className="home-dropdown" ref={dropdownRef}>
          <button
            type="button"
            className="home-dropdown__trigger"
            onClick={() => setDropdownOpen((o) => !o)}
            aria-expanded={dropdownOpen}
            aria-haspopup="true"
          >
            Menu
          </button>
          {dropdownOpen && (
            <ul className="home-dropdown__menu" role="menu">
              {latestEvent && (
                <li role="none">
                  <Link
                    to={`/survey/${latestEvent.slug}`}
                    className="home-dropdown__item"
                    role="menuitem"
                    onClick={() => setDropdownOpen(false)}
                  >
                    Most recent survey: {latestEvent.name}
                  </Link>
                </li>
              )}
              <li role="none">
                <a
                  href={'/admin'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="home-dropdown__item"
                  role="menuitem"
                  onClick={() => setDropdownOpen(false)}
                >
                  Admin pages
                </a>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

function NotFound() {
  return (
    <div className="page page--error">
      <div className="error-card">
        <h1>Not found</h1>
        <p>This survey link is invalid or the survey is closed.</p>
      </div>
    </div>
  );
}

export default App;
